module.exports = __webpack_public_path__ + "static/img/three_top_ar.6cddf146.png";